'use client';
import React from 'react';
import { MapPin } from 'lucide-react';
import { useLocation } from '@/lib/hooks/useLocation';
import { initLocation } from '@/lib/location';

export default function LocationBanner() {
  const { status } = useLocation();
  if (status !== 'pending') return null;
  return (
    <div className="flex items-center gap-3 px-5 py-3 bg-[#f0f4fc] border border-[#c8d8f5] rounded-xl text-sm">
      <MapPin size={15} className="text-[#204998] flex-shrink-0" />
      <p className="text-[#1a2744] font-medium flex-1">
        ATLAS uses your location to show nearby facilities and wait times.
      </p>
      <button
        onClick={initLocation}
        className="flex-shrink-0 text-xs font-semibold bg-[#204998] text-white px-3 py-1.5 rounded-full hover:bg-[#1a4089] transition-colors whitespace-nowrap"
      >
        Allow Location
      </button>
    </div>
  );
}
